import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { Loader } from '@percent/admin-dashboard/common/components'
import { useAuthState } from '@percent/admin-dashboard/common/hooks'

type AuthorisedRouteProps = {
  children: React.ReactNode
}

export function AuthorisedRoute({ children }: AuthorisedRouteProps) {
  const { isAuthorised, isAuthorising } = useAuthState()
  const { pathname, search } = useLocation()

  if (isAuthorising) {
    return <Loader />
  }

  if (isAuthorised) {
    return <>{children}</>
  }

  const searchParams = new URLSearchParams()
  searchParams.set('redirectTo', pathname + search)

  return <Navigate to={`/login?${searchParams.toString()}`} replace />
}
